// extracted by mini-css-extract-plugin
export default {"container":"CardWithAvatar_container__ghQbq","avatar":"CardWithAvatar_avatar__o5Xdk","body":"CardWithAvatar_body__VBMvD"};